<template>
    <div class="bg-muted-100 dark:bg-muted-900 pb-20">
        <div :class="mainClass">
            <div :class="[props.condensed && !props.horizontalScroll && 'w-full', !props.condensed && props.horizontalScroll && 'mx-auto w-full', !props.condensed && !props.horizontalScroll && 'mx-auto w-full max-w-7xl']">
                <slot name="toolbar">
                    <TairoCollapseToolbar v-if="toolbarEnabled" :collapse="false" :horizontal-scroll="props.horizontalScroll">
                        <template #title><slot name="toolbar-title"></slot></template>
                    </TairoCollapseToolbar>
                </slot>

                <slot />
            </div>
        </div>

        <TairoPanels />
    </div>
</template>

<script setup lang="ts">
import { computed, defineProps, withDefaults } from 'vue'

const props = withDefaults(
    defineProps<{
        collapse?: boolean
        toolbar?: boolean
        circularMenu?: boolean
        condensed?: boolean
        horizontalScroll?: boolean
    }>(),
    {
        collapse: true,
        toolbar: true,
        circularMenu: true,
    },
)

const app = useAppConfig()
const toolbarEnabled = computed(() => {
    return app.tairo.collapse?.toolbar?.enabled !== false && props.toolbar !== false
})

const mainClass = computed(() => {
    if (props.condensed) {
        return 'bg-muted-100 dark:bg-muted-900 relative min-h-screen w-full overflow-x-hidden'
    }

    const list = ['bg-muted-100 dark:bg-muted-900 relative min-h-screen w-full overflow-x-hidden px-4 transition-all duration-300 xl:px-10']

    if (props.horizontalScroll) {
        list.push('!pe-0 xl:!pe-0')
    }

    return list
})
</script>
